import {formatDate} from "@ui-seeker/utils";


export default function dateColumn() {
    return {
        name: 'date', label: 'Date',
        options: {
            setCellProps: () => ({ sx: { whiteSpace: 'nowrap' } }),
            customBodyRowRenderLite: value => formatDate(value, { isString: true })
        }
    }
}